var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"email-content border p-3",attrs:{"cols":"auto"}},[_vm._v(" Client review request content: "+_vm._s(_vm.locale)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }